import { useEffect, useState } from "react";
import { useCompanyContext } from "@/hooks/useCompanyContext";

const STORAGE_KEY = "heskala:offline:companyId";

/**
 * `companyId` que sobrevive offline. `useCompanyContext` lo resuelve por una
 * query reactiva de Convex, que sin conexión se queda en `undefined`; acá
 * cacheamos el último valor conocido en localStorage para poder scopear la
 * réplica offline (ver hooks/offline/useReferenceReplica.ts).
 */
export function useStableCompanyId(): string | undefined {
  const { companyId } = useCompanyContext();

  const [cached, setCached] = useState<string | undefined>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    if (!companyId) return;
    if (companyId === cached) return;
    setCached(companyId);
    try {
      localStorage.setItem(STORAGE_KEY, companyId);
    } catch {
      // localStorage puede estar bloqueado; el valor vive en memoria igual.
    }
  }, [companyId, cached]);

  return companyId ?? cached;
}
